import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import UsagePage from '@/usage/pages/usage';

export const Route = createFileRoute('/usage/water')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: WaterUsageRoute,
  staticData: {
    headerSection: 'usage'
  }
});

function WaterUsageRoute() {
  return <UsagePage accountType="water" unit="gallons"/>;
}
